import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRegistry = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4751_6928)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M14.5703 12.13L12.1297 14.5705C11.9935 14.7068 11.8318 14.8149 11.6538 14.8886C11.4758 14.9623 11.285 15.0003 11.0923 15.0002H5.46667C5.07768 15.0002 4.70463 14.8457 4.42958 14.5707C4.15452 14.2956 4 13.9226 4 13.5336V5.46691C4 5.07793 4.15452 4.70487 4.42958 4.42982C4.70463 4.15477 5.07768 4.00024 5.46667 4.00024H13.5333C13.9223 4.00024 14.2954 4.15477 14.5704 4.42982C14.8455 4.70487 15 5.07793 15 5.46691V11.0926C15 11.2852 14.9621 11.476 14.8883 11.654C14.8146 11.832 14.7065 11.9938 14.5703 12.13V12.13Z",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M1.4064 11.0002C1.14618 10.74 1 10.3871 1 10.0191V2.38776C1 2.01977 1.14618 1.66685 1.4064 1.40664C1.66661 1.14643 2.01953 1.00024 2.38752 1.00024H10.0189C10.3869 1.00024 10.7398 1.14643 11 1.40664",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4751_6928",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgRegistry);
export default ForwardRef;
